/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step5_AiInputs */

const en_dr_step5_ai = /** @type {(inputs: Dr_Step5_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarizes the reasoning, flags disagreement between voters`)
};

const id_dr_step5_ai = /** @type {(inputs: Dr_Step5_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merangkum alasan pilihan, menandai perbedaan pendapat antar-pemilih`)
};

/**
* | output |
* | --- |
* | "Summarizes the reasoning, flags disagreement between voters" |
*
* @param {Dr_Step5_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step5_ai = /** @type {((inputs?: Dr_Step5_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step5_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step5_ai(inputs)
	return en_dr_step5_ai(inputs)
});